import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { fetchDictionaryValues } from '@components/dictionary';
import { msalPlugin } from '@auth/plugin';
import { buildLoginRequest } from '@auth/requests';
import { SmsApp } from '../views';
import { b2cPostLogoutRedirectUri, b2cRedirectUri, b2cScopes } from '@/envVariables';
import { msalInstance } from '../auth/authConfig';
import i18n from '../i18n';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

await msalInstance.initialize();

fetchDictionaryValues();
const redirectRequest = buildLoginRequest(b2cRedirectUri, b2cScopes);

try {
  await msalInstance.handleRedirectPromise();
  await msalInstance.acquireTokenSilent(redirectRequest);
  createApp(SmsApp)
    .use(pinia)
    .use(i18n)
    .use(msalPlugin, msalInstance, b2cScopes)
    .mount('#sms-overlay');
} catch (error: any) {
  console.log('Error occurred returning from B2C:', error);
  if (error && error?.message?.indexOf('AADB2C90091') > -1) {
    window.location.href = b2cPostLogoutRedirectUri;
  } else {
    msalInstance.loginRedirect(redirectRequest);
  }
}
